import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const suneldConfig: TSPConfig = {
  key: 'suneld',
  name: 'SunELD',
  imageName: 'SunELD',
  category: TSPCategory.CUSTOM,
  helpText:
    'Input the API Key you use to access SunELD. Request an API Key from SunELD support if you do not have one.',
  loginComponent: (props) => (
    <LoginCreds
      onValidityChange={props.onValidityChange}
      fields={[
        {
          label: 'API Key',
          name: 'apikey',
          type: 'text',
          required: true,
        },
      ]}
    />
  ),
};

export default suneldConfig;
